import { Component } from '@angular/core';
import { MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';

@Component({
  selector: 'shell-privacy-policies',
  templateUrl: './privacy-policies.component.html',
  styleUrls: ['./privacy-policies.component.scss'],
})
export class PrivacyPoliciesComponent {
  constructor(private microFrontendRouter: MicroFrontendRouter) {}

  clickedLogo(): void {
    this.microFrontendRouter.navigateByUrl('/inicio', 'home');
  }
}
